import { Component, EventEmitter, Output, inject } from '@angular/core';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import {
  Organization,
  OrganizationStatus,
} from '@nimmsta/ng-commons-lib/models';
import {
  SaveableFormComponent,
  InputWithErrorComponent,
} from '@nimmsta/ng-commons-lib/forms';
import { ErrorComponent } from '@nimmsta/ng-commons-lib/error';
import { PartnerOrganizationService } from '@nimmsta/ng-commons-lib/services/partner-organization';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-partner-organization-form',
  templateUrl: 'partner-organization-form.component.html',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    InputWithErrorComponent,
    ErrorComponent,
  ],
})
export class PartnerOrganizationFormComponent extends SaveableFormComponent<Organization> {
  private fb = inject(FormBuilder);

  protected override dataService = inject(PartnerOrganizationService);

  @Output() override closeEvent = new EventEmitter();

  @Output() override loadingEvent = new EventEmitter<boolean>();

  parentOrganization?: Organization;

  constructor() {
    super();
    this.setValue(new Organization());
  }

  protected setFormGroup(): void {
    this.form = this.fb.group({
      id: this.value.id,
      name: [this.value.name, [Validators.required]],
      address: [this.value.address, []],
      description: [this.value.description, []],
    });
  }

  override applyCustomValues() {
    super.applyCustomValues();
    this.value = {
      ...this.value,
      parentOrganization: undefined,
      parentOrganizationId: this.parentOrganization?.id,
      status: OrganizationStatus.ACTIVE,
    } as Organization;
  }

  override setValue(value: Organization) {
    super.setValue(value);
    if (value.parentOrganization) {
      this.parentOrganization = value.parentOrganization as Organization;
    } else {
      this.parentOrganization = undefined;
    }
  }
}
